
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";


export type LoggedUser = {
    authToken?: string | null,
    sessionCode?: string | null,
    userId: number | null,
    profileComplete: boolean,
    name: string,
    mobileNumber: string | null;
    email: string | null;
    referral_code: string | null;
    isUserLoggedOut: boolean;
    openLoginModal: boolean;
}
const initialState: LoggedUser = {
    authToken: null,
    sessionCode: null,
    userId: null,
    profileComplete: false,
    name: 'Guest',
    mobileNumber: null,
    email: null,
    referral_code: null,
    isUserLoggedOut: false,
    openLoginModal: false

}

const generateSession = (): string => {
    return Math.random().toString(36).substr(2, 9);
};


const authTokenSlice = createSlice({
    name: 'JwtAuthToken_store',
    initialState,
    reducers: {
        generateSessionCode: (state, action: PayloadAction<boolean>) => {
            if (action.payload) {
                state.sessionCode = generateSession()
            } else {
                state.sessionCode = null
            }
        },
        setJwtAuthToken: (state, action: PayloadAction<LoggedUser>) => {
            state.authToken = action.payload.authToken
        },
        setLoggedUser: (state, action: PayloadAction<LoggedUser | false>) => {

            if (action.payload == false) {
                state.authToken = null;
                state.userId = null;
                state.email = null;
                state.mobileNumber = null;
                state.name = '';
                state.profileComplete = false
                state.sessionCode = null
                state.isUserLoggedOut = true;
                state.openLoginModal = false
            } else {

                state.authToken = action.payload.authToken;
                state.userId = action.payload.userId;
                state.email = action.payload.email;
                state.mobileNumber = action.payload.mobileNumber;
                state.name = action.payload.profileComplete ? action.payload.name : 'Guest';
                state.profileComplete = action.payload.profileComplete
                state.sessionCode = generateSession();
                state.isUserLoggedOut = false;
                state.openLoginModal = false
            }
        },
        updateProfileCompletedTag: (state, action: PayloadAction<{ isProfileComplete: boolean; userName: string; email: string }>) => {
            state.profileComplete = action.payload.isProfileComplete;
            state.email = action.payload.email;
            state.name = action.payload.userName;
            // state.openLoginModal = !action.payload.isProfileComplete;
        },

        setOpneLoginModal: (state, action: PayloadAction<boolean>) => {
            state.openLoginModal = action.payload;
        }
    }
})
//selectors
export const selectAuthToken = (rootState: RootState) => rootState.auth.authToken;
export const selectSessionCode = (rootState: RootState) => rootState.auth.sessionCode
export const selectLoggedUser = (rootState: RootState) => rootState.auth
export const selectProfileComplete = (rootState: RootState) => rootState.auth.profileComplete
export const selectOpenLoginModal = (rootState: RootState) => rootState.auth.openLoginModal;
export const { setJwtAuthToken, generateSessionCode, setLoggedUser, updateProfileCompletedTag, setOpneLoginModal } = authTokenSlice.actions;
export default authTokenSlice.reducer;